import { render, staticRenderFns } from "./PayPalCasesType.vue?vue&type=template&id=ac5c56b4&scoped=true"
import script from "./PayPalCasesType.vue?vue&type=script&lang=js"
export * from "./PayPalCasesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5c56b4",
  null
  
)

export default component.exports